/**
 * useApp.js
 *
 * Custom React hook for consuming the HomeIQ app context.
 *
 * Used by: All components/pages that need access to global app state/actions
 */

import { useContext } from 'react'
import { AppContext } from './AppContextDef'

export function useApp() {
  return useContext(AppContext)
}
